import styles from './index.module.css'

import React, { useMemo } from 'react'
import { humanReadableTimeZones } from '@disco/utils/time-utils'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
type Props = {
  selectedTimeZone: string | null | undefined
  // ie. America/Los_Angeles
  onSelect: (timeZone: string) => void
  selectedDate: Date
}

/**
 * A time zone picker component that displays a dropdown of available time zones
 * @param onSelect - Callback called when a time zone is selected
 * @param selectedTimeZone - The currently selected time zone (e.g., 'America/Los_Angeles')
 * @returns A time zone picker dropdown with human-readable time zone options
 */
const TimeZonePicker = ({
  onSelect,
  selectedTimeZone,
}: Props): React.ReactNode => {
  const timeZoneOptionList = useMemo(() => {
    return humanReadableTimeZones()
  }, [])
  return (
    <div className={styles.timeZonePickerContainer}>
      <CustomDropdown
        value={selectedTimeZone}
        options={timeZoneOptionList}
        placeholder="Select a time zone"
        arrowRendererIcon={'world'}
        iconStrong
        onChange={onSelect}
      />
    </div>
  )
}

export default TimeZonePicker
